var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-image-container",class:{
    watermark: _vm.watermark
  },style:({
    'paddingBottom': ((_vm.ratio * 100) + "%")
  })},[_vm._t("default",function(){return [_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }